import { Row, Modal } from 'react-bootstrap';

const CompanyNotFound = (props) => {

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        keyboard={false}
        className='cyo-modal'
        centered
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Companies not found
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <div>
              <p>Please upload proof of company ownership by clicking on your profile to submit the necessary documents.</p>
            </div>
          </Row>
        </Modal.Body>
        <Modal.Footer>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default CompanyNotFound